import axios from './defaultClient';

const nameSpace = '/ep/v1/page';

// config: 호출하는 쪽에서 axios 옵션(timeout 등)을 따로 줄 때만 쓴다. 안 넘기면 기존과 같다.
export const GetPost = async (args, config = {}) => {
    return await axios.get( nameSpace + '/', {
        ...config,
        params:{
            id: args.post_id,
        }
    })
}
export const GetPrivacy = async (args, config = {}) => {
    return await axios.get( '/ep/v1/privacy/latest/', config)
}
export const GetPrivacyList = async (args, config = {}) => {
    return await axios.get( '/ep/v1/privacy/', config)
}